<div [formGroup]="formGroup" *ngIf="!isLoading">

  <!-- Section label -->
  <div class="il-section-header" *ngIf="fields?.displayName">
    <span class="il-label" [ngClass]="{ required: fields.isRequired }">
      {{ fields.displayName }}
    </span>
    <span class="il-count" *ngIf="fieldsData?.length">
      {{ fieldsData.length }} integration{{ fieldsData.length !== 1 ? 's' : '' }}
    </span>
  </div>

  <!-- ── List container ───────────────────────────── -->
  <div class="il-list">
    <ng-container *ngFor="let option of fieldsData; let last = last; trackBy: trackById">
      <div
        *ngIf="option._id != 'None'"
        class="il-row"
        [ngClass]="{
          'il-row--connected':   isSelected(option),
          'il-row--disabled':    isDisabled(option),
          'il-row--soon':        !isSelected(option) && option.fieldDependencies == null,
          'il-row--last':        last
        }"
        [class.pointer-events-none]="isDisabled(option)"
      >

        <!-- Connected accent bar (left edge) -->
        <span class="il-accent" *ngIf="isSelected(option)"></span>

        <!-- Logo -->
        <div class="il-logo-wrap">
          <img [src]="option.iconUrl" [alt]="option.platformName" class="il-logo" />
        </div>

        <!-- Name + description -->
        <div class="il-info">
          <span class="il-name">{{ option.platformName }}</span>
          <span class="il-desc">{{ option.description }}</span>
        </div>

        <!-- Status pill -->
        <div class="il-status-wrap">
          <span class="il-pill il-pill--connected" *ngIf="isSelected(option)">
            <span class="il-pill-dot"></span>
            Connected
          </span>
          <span class="il-pill il-pill--soon" *ngIf="!isSelected(option) && option.fieldDependencies == null">
            Coming Soon
          </span>
          <span class="il-pill il-pill--idle" *ngIf="!isSelected(option) && option.fieldDependencies != null">
            Available
          </span>
        </div>

        <!-- Action button -->
        <div class="il-action">
          <button
            *ngIf="!isSelected(option) && option.fieldDependencies != null"
            class="il-btn il-btn--connect"
            [disabled]="isDisabled(option)"
            (click)="toggleSelection(option, 'connect')"
          >
            <span class="il-loader" *ngIf="loadingCards.has(option._id?.toString())"></span>
            <svg *ngIf="!loadingCards.has(option._id?.toString())"
                 width="11" height="11" viewBox="0 0 12 12" fill="none">
              <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round"/>
            </svg>
            Connect
          </button>

          <button
            *ngIf="!isSelected(option) && option.fieldDependencies == null"
            class="il-btn il-btn--soon" disabled>
            Coming Soon
          </button>

          <button
            *ngIf="isSelected(option)"
            class="il-btn il-btn--disconnect"
            (click)="toggleSelection(option, 'disconnect')">
            <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
              <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" stroke-width="1.7"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Manage
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Validation -->
  <div *ngIf="showValidationError" class="il-error">Please select an option.</div>
</div>

<!-- ── Skeleton ─────────────────────────────────────── -->
<div *ngIf="isLoading" class="il-list">
  <div *ngFor="let i of [1,2,3,4,5]; let last = last"
       class="il-row" [class.il-row--last]="last">
    <div class="il-logo-wrap">
      <div class="il-sk il-sk-logo"></div>
    </div>
    <div class="il-info">
      <div class="il-sk il-sk-name"></div>
      <div class="il-sk il-sk-desc"></div>
    </div>
    <div class="il-status-wrap">
      <div class="il-sk il-sk-pill"></div>
    </div>
    <div class="il-action">
      <div class="il-sk il-sk-btn"></div>
    </div>
  </div>
</div>

<!-- ── Connection Modal ──────────────────────────────── -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'connection_modal_' + fields.fieldName"
>
  <div class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500">
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="font-semibold text-base ms-2 card-title">{{ modalTitle }}</span>
      
    </div>
    <div class="modal-body gap-5 p-4">
      <app-modal-renderer
        #modalRendererRef
        *ngIf="activeModalContext"
        [nodeId]="currentNodeId"
        (formSaved)="onModalFormSaved($event)"
        (closeModal)="closeModal('connection_modal_' + fields.fieldName)"
        [workflowData]="workflowData"
        [recordID]="recordID"
        [workflowId]="workflowId"
        (clickedOnPrevious)="clickedOnPrevious()"
        (header)="setModalTitle($event)"
        (checkPollingServiceForError)="checkPollingServiceForError($event)"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>
